import { EActions, TReducer, TState } from './types';

export const initState: TState = {
    sortAsc: false,
    sortHeader: '',
};

const reducer: TReducer = (state, action) => {
    switch (action.type) {
        case EActions.SET_SORT_ASC:
            return {
                ...state,
                sortAsc: action.payload,
            };
        case EActions.SET_SORT_HEADER:
            return {
                ...state,
                sortHeader: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;
